<app-social-buttons
  class="sharer-buttons"
  [buttonsConfig]="buttonsConfig"
  [description]="description"
  [variant]="variant"
></app-social-buttons>
